export * from "./shared";

/**
 * WEB variant — browser paths, verbatim from `apps/web/src/utils/routeConstants.js`.
 * See `./shared.ts` for why the two platforms share exactly one symbol.
 *
 * ⚠️ `MY_ORDER_NOTIFICATION_ROUTE` is deliberately NOT redeclared here — it comes through
 * `export * from "./shared"`. It still appears as a KEY inside `ROUTE_CONSTANTS_MAP` below,
 * exactly as the app file had it; that is a literal in an object, not a second definition.
 */
export const LOGIN_ROUTE = "/login";
export const ANALYTICS_ROUTE = "/analytics";
export const REPORTS_ROUTE = "/reports";
export const ACCESS_ROUTE = "/access";
export const INVENTORY_ROUTE = "/inventory";
export const ACCOUNT_ROUTE = "/account";
export const CATALOG_ROUTE = "/catalog";
export const SETTINGS_ROUTE = "/settings";
export const CUSTOMER_ROUTE = "/customers";
export const MARKETING_ROUTE = "/marketing";
export const SUPPORT_ROUTE = "/support";
export const SERVICE_ROUTE = "/service";
export const MANAGE_TABLE_ROUTE = "/manage-table";
export const CASHIER_SETTLEMENT_ROUTE = "/cashier-settlement";
export const SUPPORT_LOGIN_ROUTE = "/support-login";
export const CASH_MANAGEMENT_ROUTE = "/cash-management";
export const OUTLET_STATUS_ROUTE = "/outlet-status";
export const REDIRECT_PAGE_ROUTE = "/redirect_page";
export const DISCOUNT_DEALS_ROUTE = "/discount-deals";
export const CHECKOUT_CONTAINER_ROUTE = "/checkout-container";
export const CUSTOMER_INFO_ROUTE = "/customer-info";
export const ITEM_STATUS_ROUTE = "/item-status";
export const DETAILS_VIEW_ROUTE = "/details-view";
export const RISTA_CARDS_ROUTE = "/rista-cards";
export const COMPANIES_ROUTE = "/companies";
export const KIOSK_HOME_ROUTE = "/kiosk-home";
export const KIOSK_APP_CONFIGURATION_ROUTE = "/kiosk-config";
export const KIOSK_PAYMENT_CONFIGURATION_ROUTE = "/kiosk-payment";
export const KIOSK_CHANNEL_MAPPING_ROUTE = "/kiosk-channel";
/** Customer-display screen (release_4.0.0, DP-7811). Both names resolve to the same path. */
export const CUSTOMER_DISPLAY_SCREEN = "/customer-display";
export const CUSTOMER_DISPLAY_SETTINGS_ROUTE = "/customer-display";

export const ROUTE_CONSTANTS_MAP = {
  LOGIN_ROUTE: "/login",
  NEW_ORDER_ROUTE: "/new-order",
  // The kiosk shell mounts at this PARENT path; every kiosk screen is a child of it
  // (`@rista/core/kiosk/navigation/routes` holds the relative paths). `history.js` reads
  // this key to decide whether a navigation is leaving kiosk mode, so it is load-bearing
  // for the one-way-door guard, not just a route table entry.
  KIOSK_ROUTE: "/kiosk",
  MY_ORDER_ROUTE: "/my-orders",
  TABLE_VIEW_ROUTE: "/table-view",
  RESERVATIONS_ROUTE: "/reservations",
  ANALYTICS_ROUTE: "/analytics",
  REPORTS_ROUTE: "/reports",
  ACCESS_ROUTE: "/access",
  INVENTORY_ROUTE: "/inventory",
  CATALOG_ROUTE: "/catalog",
  CUSTOMER_ROUTE: "/customers",
  MARKETING_ROUTE: "/marketing",
  SUPPORT_ROUTE: "/support",
  CHANGE_BUSINESS_ROUTE: "/change-business",
  SERVICE_ROUTE: "/service",
  SETTINGS_ROUTE: "/settings",
  MANAGE_TABLE_ROUTE: "/manage-table",
  CASHIER_SETTLEMENT_ROUTE: "/cashier-settlement",
  CASH_MANAGEMENT_ROUTE: "/cash-management",
  MY_ORDER_NOTIFICATION_ROUTE: "/my-orders?channel=delivery&orderTab=new",
  SUPPORT_LOGIN_ROUTE: "/support-login",
  OUTLET_STATUS_ROUTE: "/outlet-status",
  REDIRECT_PAGE_ROUTE: "/redirect_page",
  DISCOUNT_DEALS_ROUTE: "/discount-deals",
  CHECKOUT_CONTAINER_ROUTE: "/checkout-container",
  CUSTOMER_INFO_ROUTE: "/customer-info",
  ITEM_STATUS_ROUTE: "/item-status",
  DETAILS_VIEW_ROUTE: "/details-view",
  ACCOUNTING_ROUTE: "/accounting",
  PNL_STATEMENT: "/pnl_statement",
  SALES_AUDIT: "/sales-audit",
  ACCOUNT_SUMMARY: "/account-summary",
  FINANCE_INVENTORY_MODULE: "/finance-inventory-module",
  RISTA_CARDS_ROUTE: "/rista-cards",
  COMPANIES_ROUTE: "/companies",
  KIOSK_HOME_ROUTE: "/kiosk-home",
  KIOSK_APP_CONFIGURATION_ROUTE: "/kiosk-config",
  KIOSK_PAYMENT_CONFIGURATION_ROUTE: "/kiosk-payment",
  KIOSK_CHANNEL_MAPPING_ROUTE: "/kiosk-channel",
  CUSTOMER_DISPLAY_SCREEN: "/customer-display",
  CUSTOMER_DISPLAY_SETTINGS_ROUTE: "/customer-display",
};
